import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace('#', '?')).get('session_id');

    if (!sessionId) {
      navigate('/', { replace: true });
      return;
    }

    const exchangeSession = async () => {
      try {
        const response = await axios.post(
          `${API}/api/auth/google-session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        const user = response.data;
        // Store auth state
        localStorage.setItem('managerLoggedIn', 'true');
        localStorage.setItem('managerName', user.name || user.email);
        localStorage.setItem('googleAuth', 'true');
        if (user.token) {
          localStorage.setItem('authToken', user.token);
        }

        // Clear hash and navigate
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/home', { replace: true, state: { user } });
      } catch (error) {
        console.error('Google auth failed:', error);
        sessionStorage.setItem('loginError', error.response?.data?.detail === 'Invalid session'
          ? 'ההתחברות עם חשבון גוגל נכשלה, נסה שוב'
          : (error.response?.data?.detail || 'ההתחברות עם חשבון גוגל נכשלה, נסה שוב'));
        window.history.replaceState(null, '', '/');
        navigate('/', { replace: true });
      }
    };

    exchangeSession();
  }, [navigate]);

  return null; // No loading UI - process silently
};

export default AuthCallback;
